import { defaultVortexTheme } from "../themes/default-vortex-theme"

export const primaryVortexTheme = defaultVortexTheme
